<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <!--<ul class="footer-menu">-->
          <!--<li>-->
            <!--<a class="navbar-brand" href="#dashboard">-->
              <!--{{$route.name}}-->
            <!--</a>-->
          <!--</li>-->
        <!--</ul>-->
      </nav>
      <div class="copyright">
        &copy; {{year}},
        <a href="https://oneclose.ca/" target="_blank" rel="noopener noreferrer">OneClose</a> Inc.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }

</script>
<style>

</style>
